import { createStyles, makeStyles } from '@material-ui/core'

export const usePlainHeaderStyles = makeStyles(() =>
  createStyles({
    root: {
      padding: '29px 79px 23px',
      boxShadow: '0px 4px 73px rgba(0, 0, 0, 0.08)'
    }
  })
)
